import React from 'react'
import { ReduxProvider } from '@/components/providers/redux-provider'
import { ThemeProvider } from '@/components/providers/theme-provider'
import { ToastProvider } from '@/components/providers/toast-provider'
import { ReadonlyModeProvider } from '@/contexts/ReadonlyModeContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { CacheBootstrapProvider } from '@/components/providers/cache-bootstrap-provider'
import { LocaleSync } from '@/i18n/LocaleSync'
import { ProductChoiceHost } from '@/components/asset-mgr/product/ProductChoiceDialog'

// 🔧 NovuProviderWrapper 移到 Layout 中，避免认证过程中的组件树重建导致页面闪烁
// import { NovuProviderWrapper } from '@/components/notifications'

interface ProvidersProps {
  children: React.ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ThemeProvider defaultTheme="system">
      <ReduxProvider>
        <LocaleSync />
        <ReadonlyModeProvider>
          {/* 🔥 新的认证提供者 - 使用 Clerk publicMetadata 驱动的状态机 */}
          <AuthProvider>
            {/* 版本号驱动缓存 bootstrap（OpenSpec add-version-based-cache） */}
            <CacheBootstrapProvider>
              {children}
            </CacheBootstrapProvider>
          </AuthProvider>
          <ToastProvider />
          {/* 建产品 / 建采购「目录里可能已有」的询问（askProductChoice） */}
          <ProductChoiceHost />
        </ReadonlyModeProvider>
      </ReduxProvider>
    </ThemeProvider>
  )
} 